<template>
    <form @submit.prevent="searchByEmail" 
        class="invite-modal__form">
        <div class="invite-modal__row">
            <label class="invite-modal__form-control invite-modal__form-control_full-size">
                <span class="invite-modal__label">Email</span>
                <input class="invite-modal__field"
                    type="text" 
                    placeholder="Email"
                    v-model="email" 
                />
            </label>
            <button class="invite-modal__button invite-modal__button_submit invite-modal__apply-email"
                :disabled="!email">Apply</button>
            <div v-if="isUserSearching"
                class="invite-modal__loader">
                <base-loader />
            </div>
        </div>
        <div class="invite-modal__subtitle">Did you know?</div>
        <p class="invite-modal__text">Once a user is invited to your project, they will be available to assign to workflows in your content briefs.</p>
        <div class="invite-modal__controls">
            <button class="invite-modal__button invite-modal__button_single-cancel" 
                type="button"
                @click="cancel">Cancel</button>
        </div>
    </form>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
    name: 'InviteUserPopupStep1',
    data() {
        return {
            email: '',
        }
    },
    computed: {
        ...mapState('users', [
            'isUserSearching'
        ]),
        trimmedEmail() {
            return this.email.trim()
        }
    },
    methods: {
        ...mapActions('users', [
            'findUserByEmail'
        ]),
        async searchByEmail() {
            const userData = await this.findUserByEmail({
                email: this.trimmedEmail,
                clientId: this.clientId
            });
            const data = userData || this.trimmedEmail
            this.$emit('search-result', data)
        },
        cancel() {
            this.$emit('cancel')
        }
    }
}
</script>

<style scoped lang="scss">
.invite-modal {
    &__row {
        position: relative;
    }

    &__apply-email {
        margin-bottom: 20px;
    }

    &__loader {
        bottom: 10px !important;
    }
}
</style>